import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { BarcodeOutlined, ExportOutlined, ImportOutlined, MoreOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Dropdown, Input, Menu, Modal, Select, Tag, Spin, Typography, Tooltip, notification } from 'antd';
import { Api } from '../../lib/api';
import { hash, removeHash, validateHash } from '../../lib/utils';
import {
    TEST_PLAN_TEMPLATE__SIMPLEX,
    TEST_PLAN_TEMPLATE__DUPLEX,
    TEST_PLAN_TEMPLATE__MULTIFIBER,
    TEST_PLAN_TEMPLATE__FAN_OUT,
    TEST_PLAN_TEMPLATES_BY_ID,
    CORE_SIZE__SINGLEMODE,
    CORE_SIZE__MULTIMODE_50,
    CORE_SIZE__MULTIMODE_62_5,
    MTJ__SINGLE_END_A,
    MTJ__SINGLE_END_B,
    MTJ__SINGLE_END_A_THEN_END_B,
    MTJ__DOUBLE,
    ASSEMBLY_LENGTH__LT_100_M,
    ASSEMBLY_LENGTH__LT_500_M,
    ASSEMBLY_LENGTH__LT_1500_M,
    ASSEMBLY_LENGTH__LT_4000_M
} from '@shared/constants/constants';
import Cable from '../../images/cable';
import simplexIcon from '../../images/1_simplex_A_BW_square.png';

import duplexIcon from '../../images/2_duplex_B_BW_square.png';
import multifiberIcon from '../../images/4_multifiber_A_BW_square.png';
import fanOutIcon from '../../images/5_fanout_to_multifiber_B_BW_square.png';
import Highlighter from 'react-highlight-words';

import Media from 'react-media';

import BarcodeT from '../barcode';

import { saveAs } from 'file-saver';

import { VirtualTable } from '../../controls/VirtualTable';

import DeleteWarningModal from '../settings/components/DeleteWarningModal';
import RenameModal from '../components/RenameModal';

const { Text } = Typography;
const CABLE_CORE_SIZE_NAME = {
    [CORE_SIZE__SINGLEMODE]: 'SM 9/125',
    [CORE_SIZE__MULTIMODE_50]: 'MM 50/125',
    [CORE_SIZE__MULTIMODE_62_5]: 'MM 62.5/125'
};
const MTJ_CONFIG = {
    [MTJ__SINGLE_END_A_THEN_END_B]: <Text>Single MTJ (Both Ends)</Text>,
    [MTJ__DOUBLE]: <Text>Dual MTJ</Text>,
    [MTJ__SINGLE_END_A]: <Text>Single MTJ (End A)</Text>,
    [MTJ__SINGLE_END_B]: <Text>Single MTJ (End B)</Text>
};

const ASSEMBLY_LENGTH = {
    [ASSEMBLY_LENGTH__LT_100_M]: '< 100m',
    [ASSEMBLY_LENGTH__LT_500_M]: '< 500m',
    [ASSEMBLY_LENGTH__LT_1500_M]: '< 1500m',
    [ASSEMBLY_LENGTH__LT_4000_M]: '< 4000m'
};

class TestPlans extends Component {
    constructor() {
        super();

        this.state = {
            searchTerm: '',

            showDropArea: false,
            showRenameModal: false,
            renameUUID: null,
            renameName: '',
            testPlans: [],
            testPlansTemp: [],
            unselectedTestPlans: [],
            selectedTestPlans: [],
            printVisible: false,
            url: '',
            loading: false,
            loadingTable: false,
            confirmDeleteTestPlan: false,
            testPlanName: null,
            barcodeVisible: false,
            uuid: null,
            testName: '',
            offset: 1,
            currentTestPlan: null,

            labels: [],
        };

        this.getTestPlans = this.getTestPlans.bind(this);
    }

    componentDidMount() {
        this.getTestPlans();
        this.getLabels();
    }

    componentWillUnmount() {
        //  clearInterval(this.testPlanIntervalId);
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 6, marginTop: -100 }}>
                {dataIndex === 'name' ? (
                    <Input
                        ref={(node) => {
                            this.searchInput = node;
                        }}
                        placeholder={`Search by ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={(e) => {
                            setSelectedKeys(e.target.value ? [e.target.value] : []);

                            this.setState({ searchTerm: e.target.value });
                        }}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    />
                ) : (
                    <>tesss</>
                )}
            </div>
        ),
        filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : '#87CEEB' }} />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            )
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex
        });
    };

    handleReset = (clearFilters) => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    getTestPlans = async () => {
        this.setState({ loadingTable: true });
        Api.getTestPlans().then((testPlans) => {
            this.setState({
                testPlans: testPlans,
                loadingTable: false
            });
        });
    };

    getLabels() {
        this.setState({ loadingTable: true });
        
        Api.getLabels().then((labels) => {
            this.setState({ labels: labels, loadingTable: false });
        });
    }

    getUnselectedTestPlans() {
        Api.getTestPlans().then((testPlans) => {
            this.setState({ unselectedTestPlans: testPlans });
        });
    }

    closeDeleteModal = () => {
        this.setState({
            confirmDeleteTestPlan: false
        });
    };

    download(id) {
        Api.getTestPlan(id).then((testPlan) => {
            let link = document.createElement('a');
            let name = testPlan.name.replace(/[^\w -]/g, ' ').trim();
            link.download = name.length > 0 ? name + '.txt' : 'test_plan.txt';
            let json = JSON.stringify(testPlan);
            link.href = 'data:,' + hash(json) + encodeURIComponent(json);
            link.click();
        });
    }

    import() {
        let input = document.createElement('input');
        input.type = 'file';
        input.setAttribute('multiple', '');

        input.addEventListener('change', (event) => {
            for (let i = 0; i < input.files.length; i++) {
                this.importFile(input.files[i]);
            }
        });

        input.click();
    }

    importFile(file) {
        let reader = new FileReader();
        reader.onload = async (text) => {
            try {
                const testPlan = text.target.result;

                const result = await Api.importTestPlan(testPlan);

                // Refresh test plan list
                this.getTestPlans();

                notification.success({
                    message: 'Import Successful',
                    description: `Test Plan "${result.testPlan}" imported successfully.`,
                    placement: 'bottomRight',
                    duration: 5,
                })
            } catch (e) {
                console.error(e);
                
                notification.error({
                    message: 'Import Failed',
                    description: `Failed to import Test Plan from file "${file.name}". Error: ${e.message}`,
                    placement: 'bottomRight',
                    duration: 8,
                })
            }
        };

        reader.readAsText(file);
    }

    onDrop(event) {
        event.preventDefault();
        event.stopPropagation();

        for (var i = 0; i < event.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (event.dataTransfer.items[i].kind !== 'file') {
                continue;
            }

            let file = event.dataTransfer.items[i].getAsFile();

            this.importFile(file);
        }

        this.setState({ showDropArea: false });
    }

    onDragOver(event) {
        this.setState({ showDropArea: true });
        event.preventDefault();
        event.stopPropagation();
    }

    onDragLeave(event) {
        this.setState({ showDropArea: false });
        event.preventDefault();
        event.stopPropagation();
    }

    async duplicate(id, currentName) {
        try {
            await Api.cloneTestPlan({ id: id, name: 'Copy of ' + currentName });

            this.getTestPlans();
        } catch(e) {
            console.error(e);

            notification.error({
                message: 'Duplication Failed',
                description: `Failed to duplicate Test Plan. Error: ${e.message}`,
                placement: 'bottomRight',
                duration: 8,
            });
        }
    }

    deleteTestPlan = async (id) => {
        await Api.deleteTestPlan(id);
        this.setState({ currentTestPlan: null });
    };

    async renameTestPlan(uuid, newName) {
        await Api.updateTestPlan(uuid, { name: newName });
    }

    s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }

    closeHandler = () => {
        this.setState({ barcodeVisible: false });
    };

    openRenameModal(record) {
        this.setState({
            renameUUID: record.uuid,
            renameName: record.name,
            showRenameModal: true
        });
    }

    closeRenameModal = () => {
        this.setState({ showRenameModal: false });
    };

    render() {
        return (
            <div id="test-plans-page">
                <DeleteWarningModal
                    isOpen={this.state.confirmDeleteTestPlan}
                    itemTypeToDelete={'Test Plan'}
                    itemNameToDelete={this.state.currentTestPlan?.name}
                    itemRecordToDelete={this.state.currentTestPlan?.id}
                    closeCallback={this.closeDeleteModal}
                    delete={this.deleteTestPlan}
                    update={this.getTestPlans}
                ></DeleteWarningModal>
                <RenameModal
                    isOpen={this.state.showRenameModal}
                    uuid={this.state.renameUUID}
                    name={this.state.renameName}
                    closeCallback={this.closeRenameModal}
                    refreshCallback={this.getTestPlans}
                    rename={this.renameTestPlan}
                    type={'test plan'}
                ></RenameModal>
                <div id="template-list">
                    <TemplateType src={simplexIcon} title=" New Simplex" testPlanTemplate={TEST_PLAN_TEMPLATE__SIMPLEX} />
                    <TemplateType src={duplexIcon} title=" New Duplex" testPlanTemplate={TEST_PLAN_TEMPLATE__DUPLEX} />
                    <TemplateType
                        src={multifiberIcon}
                        title="New Multifiber"
                        testPlanTemplate={TEST_PLAN_TEMPLATE__MULTIFIBER}
                    />
                    <TemplateType src={fanOutIcon} title="New Fan-out" testPlanTemplate={TEST_PLAN_TEMPLATE__FAN_OUT} />
                    <div onClick={() => this.import()} className="fancy_card img-hover-zoom--colorize">
                        <ImportOutlined className="card_image svg" />
                        <div className="title-fiber">Import</div>
                    </div>
                </div>
                <div id="test-plan-list" onDrop={(e) => this.onDrop(e)} onDragOver={(e) => this.onDragOver(e)}>
                    {this.state.showDropArea && <div className="drop-area" onDragLeave={(e) => this.onDragLeave(e)}></div>}
                    <div className="search-bar">
                        {this.state.printVisible && (
                            <React.Fragment>
                                <Modal
                                    title="Export Barcodes"
                                    open={this.state.printVisible}
                                    //onOk={this.handleRenameOk}
                                    onCancel={() =>
                                        this.setState({ printVisible: false, selectedTestPlans: [], unselectedTestPlans: [] })
                                    }
                                    footer={
                                        <div className="footer">
                                            <div className="buttons">
                                                <Button
                                                    type="primary"
                                                    disabled={this.state.selectedTestPlans.length === 0}
                                                    onClick={() => {
                                                        this.setState({ loading: true });
                                                        Api.exportBarcode(this.state.selectedTestPlans).then((result) => {
                                                            let data = new Uint8Array(result.data);
                                                            let pdfBolb = new Blob([data], { type: 'application/pdf' });

                                                            saveAs(pdfBolb, 'Barcodes.pdf');
                                                            this.setState({ loading: false });
                                                        });
                                                    }}
                                                >
                                                    Export
                                                </Button>
                                                <Button
                                                    onClick={() => {
                                                        this.setState({
                                                            printVisible: false,
                                                            selectedTestPlans: [],
                                                            unselectedTestPlans: []
                                                        });
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    }
                                >
                                    <React.Fragment>
                                        <Modal open={this.state.loading} footer={null} closable={null}>
                                            <div style={{ textAlign: 'center' }}>
                                                {' '}
                                                <Spin tip="Loading..." />
                                            </div>
                                        </Modal>
                                        <div>Select a test plan:</div>

                                        {this.state.unselectedTestPlans && (
                                            <Select
                                                value={
                                                    this.state.selectedTestPlans.length !== 0
                                                        ? this.state.unselectedTestPlans.length !== 0
                                                            ? this.state.selectedTestPlans[
                                                                  this.state.selectedTestPlans.length - 1
                                                              ].name
                                                            : 'All'
                                                        : null
                                                }
                                                onChange={(testPlanId) => {
                                                    if (testPlanId) {
                                                        if (testPlanId === 'All') {
                                                            let all = [
                                                                ...this.state.selectedTestPlans,
                                                                ...this.state.unselectedTestPlans
                                                            ];

                                                            this.setState({
                                                                selectedTestPlans: all,
                                                                unselectedTestPlans: [],
                                                                testPlanName: 'All'
                                                            });
                                                        } else {
                                                            let testPlan = this.state.unselectedTestPlans.filter((obj) => {
                                                                return obj.id === testPlanId;
                                                            });

                                                            let unselectedTestPlans = this.state.unselectedTestPlans.filter(
                                                                (test) => test !== testPlan[0]
                                                            );

                                                            let selectedTestPlans =
                                                                this.state.selectedTestPlans.concat(testPlan);

                                                            this.setState({
                                                                selectedTestPlans: selectedTestPlans,
                                                                unselectedTestPlans: unselectedTestPlans,
                                                                testPlanName: testPlan[0].name
                                                            });
                                                        }
                                                    }
                                                }}
                                                style={{ width: '100%' }}
                                            >
                                                <Select.Option value={'All'}>All</Select.Option>
                                                {this.state.unselectedTestPlans.map((testPlan) => (
                                                    <Select.Option key={testPlan.id} value={testPlan.id}>
                                                        {testPlan.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}

                                        {this.state.selectedTestPlans.length > 0 && (
                                            <React.Fragment>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        flexWrap: 'wrap',
                                                        paddingTop: '5px'
                                                    }}
                                                >
                                                    {this.state.selectedTestPlans.map((testPlan) => (
                                                        <React.Fragment key={testPlan.id}>
                                                            <Tag
                                                                closable
                                                                //color="	#87CEFA"
                                                                style={{ marginBottom: '5px' }}
                                                                onClose={(e) => {
                                                                    e.preventDefault();
                                                                    //this.handleClose(tag);

                                                                    let selectedTestPlans_1 =
                                                                        this.state.selectedTestPlans.filter(
                                                                            (test) => test !== testPlan
                                                                        );
                                                                    let unselectedTestPlans_1 =
                                                                        this.state.unselectedTestPlans.concat(testPlan);
                                                                    this.setState({
                                                                        selectedTestPlans: selectedTestPlans_1,
                                                                        unselectedTestPlans: unselectedTestPlans_1
                                                                    });
                                                                }}
                                                            >
                                                                {testPlan.name}
                                                            </Tag>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                </Modal>
                            </React.Fragment>
                        )}
                    </div>
                    {this.state.barcodeVisible && (
                        <BarcodeT
                            barcodeVisible={this.state.barcodeVisible}
                            closeHandler={this.closeHandler}
                            uuid={this.state.uuid}
                            testName={this.state.testName}
                        />
                    )}

                    <div className="card">
                        <Media query="(min-width: 1600px)">
                            {(matches) => {
                                let columns = [
                                    {
                                        title: !matches && (
                                            <Dropdown
                                                overlay={
                                                    <Menu>
                                                        <Menu.Item
                                                            onClick={() => {
                                                                this.getUnselectedTestPlans();
                                                                this.setState({ printVisible: true, testPlanName: null });
                                                            }}
                                                        >
                                                            Export Barcodes as PDF
                                                        </Menu.Item>
                                                    </Menu>
                                                }
                                                trigger={['click']}
                                            >
                                                <div className="menu-label">
                                                    <MoreOutlined />
                                                </div>
                                            </Dropdown>
                                        ),
                                        width: '62px',
                                        align: 'center',
                                        render: (text, record) => (
                                            <Dropdown
                                                overlay={
                                                    <Menu>
                                                        {
                                                            !matches && (
                                                                <Fragment>
                                                                    <Menu.Item
                                                                        onClick={() =>
                                                                            this.setState({
                                                                                barcodeVisible: true,
                                                                                uuid: record.uuid,
                                                                                testName: record.name
                                                                            })
                                                                        }
                                                                    >
                                                                        Show Barcode
                                                                    </Menu.Item>
                                                                    <Menu.Divider />
                                                                </Fragment>
                                                            )
                                                        }
                                                        <Menu.Item
                                                            key={`edit-${record.id}`}
                                                            onClick={() =>
                                                                this.props.history.push(`/wizard/${record.id}`)
                                                            }
                                                            disabled={record.manuallyEdited}
                                                        >
                                                            Edit
                                                        </Menu.Item>
                                                        <Menu.Item key={`rename-${record.id}`} onClick={() => this.openRenameModal(record)}>
                                                            Rename
                                                        </Menu.Item>
                                                        <Menu.Item key={`duplicate-${record.id}`} onClick={() => this.duplicate(record.id, record.name)}>
                                                            Duplicate
                                                        </Menu.Item>
                                                        <Menu.Item key={`export-${record.id}`} onClick={() => this.download(record.id)}>
                                                            Export
                                                        </Menu.Item>
                                                        <Menu.Divider />
                                                        <Menu.Item
                                                            key={`delete-${record.id}`}
                                                            danger
                                                            onClick={() =>
                                                                this.setState({
                                                                    confirmDeleteTestPlan: true,
                                                                    currentTestPlan: record
                                                                })
                                                            }
                                                        >
                                                            Delete
                                                        </Menu.Item>
                                                    </Menu>
                                                }
                                                trigger={['click']}
                                            >
                                                <div className="menu-label">
                                                    <MoreOutlined />
                                                </div>
                                            </Dropdown>
                                        )
                                    },
                                    {
                                        width: '62px',
                                        align: 'center',
                                        dataIndex: 'testPlanTemplateId',
                                        render: (text, record) => (
                                            <Cable
                                                testPlanTemplate={
                                                    record.testPlanTemplateId in TEST_PLAN_TEMPLATES_BY_ID
                                                        ? TEST_PLAN_TEMPLATES_BY_ID[record.testPlanTemplateId].name
                                                        : ''
                                                }
                                                coreSize={record.cableCoreSize}
                                            />
                                        )
                                    },
                                    {
                                        title: 'Test Plan Name',
                                        dataIndex: 'name',
                                        sorter: (a, b) => a.name.localeCompare(b.name),
                                        //onFilter: (value, record) => record.name.indexOf(value) === 0,
                                        ...this.getColumnSearchProps('name'),
                                        render: (text) => (
                                            <Tooltip title={text}>
                                                <Text data-testid="test-plan-name" strong>{text}</Text>
                                            </Tooltip>
                                        )
                                    },
                                    {
                                        title: 'Core Size',
                                        dataIndex: 'cableCoreSize',
                                        align: 'center',
                                        render: (text) => CABLE_CORE_SIZE_NAME[text]
                                    },
                                    {
                                        title: 'MTJ Config',
                                        align: 'center',
                                        render: (text, record) =>
                                            record.wizardData !== null
                                                ? MTJ_CONFIG[record.wizardData.equipment.mtjConfiguration]
                                                : 'none'
                                    },

                                    {
                                        title: <>Assembly Type (Cable, Fiber)</>,
                                        align: 'center',
                                        render: (text, record) =>
                                            record.wizardData !== null ? (
                                                <Text>
                                                    {record.testPlanTemplateId in TEST_PLAN_TEMPLATES_BY_ID
                                                        ? TEST_PLAN_TEMPLATES_BY_ID[record.testPlanTemplateId].name +
                                                          ' (' +
                                                          record.wizardData.cablesPerAssembly +
                                                          ',' +
                                                          record.wizardData.fibersPerCable +
                                                          ')'
                                                        : '' +
                                                          '(' +
                                                          record.wizardData.cablesPerAssembly +
                                                          ',' +
                                                          record.wizardData.fibersPerCable +
                                                          ')'}
                                                </Text>
                                            ) : (
                                                'none'
                                            )
                                    },
                                    {
                                        title: 'Wavelengths',
                                        align: 'center',
                                        render: (text, record) =>
                                            record.wizardData !== null ? (
                                                <Text>
                                                    {record.wizardData.wavelength_850 && <>850 </>}{' '}
                                                    {record.wizardData.wavelength_1300 && <>1300 </>}{' '}
                                                    {record.wizardData.wavelength_1310 && <>1310 </>}{' '}
                                                    {record.wizardData.wavelength_1490 && <>1490 </>}{' '}
                                                    {record.wizardData.wavelength_1550 && <>1550 </>}{' '}
                                                    {record.wizardData.wavelength_1625 && <>1625 </>}{' '}
                                                </Text>
                                            ) : (
                                                'none'
                                            )
                                    },
                                    {
                                        title: 'Assembly Length',
                                        align: 'center',
                                        render: (text, record) =>
                                            record.wizardData !== null
                                                ? ASSEMBLY_LENGTH[record.wizardData.assemblyLength]
                                                : 'none'
                                    },
                                    {
                                        title: 'Label',
                                        align: 'center',
                                        render: (text, record) =>
                                        {
                                            let labels = [];

                                            if(record.labels.length > 0)
                                            {
                                                labels = labels.concat(record.labels.map(label => label.name));
                                            }

                                            if(record.wizardData?.excelLabel) {
                                                if(typeof record.wizardData.excelLabel === 'number')
                                                {
                                                    let excelLabel = this.state.labels.find(label => label.id === record.wizardData.excelLabel);
                                                    
                                                    if(excelLabel) {
                                                        labels.push(excelLabel.name);
                                                    }
                                                } else {
                                                    labels.push(record.wizardData.excelLabel);
                                                }
                                            }

                                            if (record.wizardData?.secondExcelLabel) {
                                                if(typeof record.wizardData.secondExcelLabel === 'number')
                                                {
                                                    let excelLabel = this.state.labels.find(label => label.id === record.wizardData.secondExcelLabel);

                                                    if(excelLabel) {
                                                        labels.push(excelLabel.name);
                                                    }
                                                } else {
                                                    labels.push(record.wizardData.secondExcelLabel);
                                                }
                                            }

                                            if(labels.length === 0)
                                            {
                                                labels.push('None');
                                            }

                                            return (
                                                labels.map((label, index) => (
                                                    <div key={index}>
                                                        <Text underline={label !== 'None'}>{label}</Text>
                                                    </div>
                                                ))
                                            );
                                        }
                                    },
                                    {
                                        title: (
                                            <Tooltip title="Export Barcodes as Pdf">
                                                <Button
                                                    onClick={() => {
                                                        this.getUnselectedTestPlans();
                                                        this.setState({ printVisible: true, testPlanName: null });
                                                    }}
                                                    icon={<ExportOutlined />}
                                                    shape="round"
                                                >
                                                    Barcodes
                                                </Button>
                                            </Tooltip>
                                        ),
                                        align: 'center',
                                        responsive: ['xxl'],
                                        render: (text, record) => (
                                            <Button
                                                type="primary"
                                                shape="round"
                                                icon={<BarcodeOutlined />}
                                                onClick={() =>
                                                    this.setState({
                                                        barcodeVisible: true,
                                                        uuid: record.uuid,
                                                        testName: record.name
                                                    })
                                                }
                                            >
                                                Barcode
                                            </Button>
                                        )
                                    }
                                ];

                                return (
                                    <VirtualTable
                                        columns={columns}
                                        dataSource={
                                            this.state.searchTerm === ''
                                                ? this.state.testPlans
                                                : this.state.testPlans.filter(
                                                      ({ name }) =>
                                                          name.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) !== -1
                                                  )
                                        }
                                        rowKey="id"
                                        sticky={true}
                                        pagination={false}
                                        scroll={{ y: 'max-content' }}
                                        loading={this.state.loadingTable}
                                        scrollToFirstRowOnChange={false}
                                    />
                                );
                            }}
                        </Media>
                        {/* </RefWrap> */}
                    </div>
                </div>
            </div>
        );
    }
}

class TemplateType extends Component {
    static propTypes = {
        src: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        testPlanTemplate: PropTypes.string.isRequired
    };

    render() {
        return (
            <Link
                data-testid={`test-plan-template-${this.props.testPlanTemplate.replace(' ', '').toLowerCase()}`}
                to={{ pathname: `/wizard/new/${this.props.testPlanTemplate}` }}
            >
                <div>
                    <div className="fancy_card img-hover-zoom--colorize">
                        <img className="card_image" src={this.props.src} alt={this.props.title} />
                        <div className="title-fiber">{this.props.title}</div>
                    </div>
                </div>
            </Link>
        );
    }
}
export class RefWrap extends React.Component {
    componentDidMount() {
        const { setRef } = this.props;
        // eslint-disable-next-line react/no-find-dom-node
        if (setRef) setRef(ReactDOM.findDOMNode(this));
    }
    render() {
        const { children } = this.props;
        return React.Children.only(children);
    }
}

export default withRouter(TestPlans);
